<template>
  <ErrorModal v-if="error.show" :data="error.data" :load-times="true" />
  <reservationheader :step="3" />
  <reservationinfobar :step="3" v-if="resnormal" />
  <reservationinfobarAbo :step="3" disabled v-else />

  <div class="orm-container-fluid orm-reservation__data__container">
    <div class="orm-container">
      <div class="orm-row">
        <div class="orm-col-xs-12 orm-col-md-9">
          <div class="orm-reservation__data__container__inner orm-my-16">
            <h1 class="orm-headline__h1">{{ i18n("step3/headline") }}</h1>
            <div class="orm-row">
              <div class="orm-col-xs-12 orm-col-sm-6">
                <h2 class="orm-headline__h3">
                  {{ i18n("form/personaldata") }}
                </h2>
                <div
                  class="orm-form__block orm-form__container"
                  v-if="form.customer && requirements"
                >
                  <form-select
                    my-id="formSalutation"
                    :my-label="i18n('form/label/salutation')"
                    :my-options="salutationMethods"
                    my-options-value="id"
                    my-options-text="salutation"
                    :my-placeholder="i18n('form/placeholder/salutation')"
                    :is-required="getRequirement('salutation_id')"
                    :error="validate.salutation_id"
                    v-model="form.customer.salutation_id"
                    :is-readonly="isLoggedin"
                    v-if="!isLoggedin"
                  ></form-select>
                  <form-input
                    v-if="form.customer.salutation_id && isLoggedin"
                    my-id="formSalutation"
                    :my-label="i18n('form/label/salutation')"
                    :is-readonly="true"
                    :is-required="true"
                    :model-value="
                      store.getters['customer/GET_SALUTATION'](
                        form.customer.salutation_id
                      )
                    "
                  ></form-input>
                  <!-- <form-input
                  my-id="formTitle"
                  my-label="Titel"
                  v-model="form.customer.title"
                ></form-input> -->
                  <form-input
                    my-id="formName"
                    :my-label="i18n('form/label/name') || 'Name'"
                    :is-required="getRequirement('name1')"
                    v-model="form.customer.name1"
                    :is-readonly="isLoggedin"
                    v-if="isLoggedin && getVisibility('name1')"
                  ></form-input>
                  <form-input
                    my-id="formFirstname"
                    :my-label="i18n('form/label/firstname')"
                    :is-required="getRequirement('firstname')"
                    :error="validate.firstname"
                    v-model="form.customer.firstname"
                    :is-readonly="isLoggedin"
                    v-if="!isLoggedin && getVisibility('firstname')"
                  ></form-input>
                  <form-input
                    my-id="formLastname"
                    :my-label="i18n('form/label/lastname')"
                    :is-required="getRequirement('lastname')"
                    :error="validate.lastname"
                    v-model="form.customer.lastname"
                    :is-readonly="isLoggedin"
                    v-if="!isLoggedin && getVisibility('lastname')"
                  ></form-input>
                  <form-input
                      v-if="getVisibility('email')"
                    my-id="formEmail"
                    :my-label="i18n('form/label/email')"
                    my-type="email"
                    :is-required="getRequirement('email')"
                    :error="validate.email"
                    v-model="form.customer.email"
                    :is-readonly="isLoggedin"
                  ></form-input>
                  <small v-if="erroremailexist" class="orm-login-error"
                    >{{ i18n("form/label/email") }} existiert bereits.</small
                  >
                  <form-input
                      v-if="getVisibility('phone_number')"
                    my-id="formPhone"
                    :my-label="i18n('form/label/phone')"
                    :is-required="getRequirement('phone_number')"
                    :error="validate.phone_number"
                    my-type="tel"
                    v-model="form.customer.phone_number"
                    :is-readonly="isLoggedin"
                  ></form-input>
                  <form-input
                      v-if="getVisibility('company_name')"
                    my-id="formCompany"
                    :my-label="i18n('form/label/company')"
                    :is-required="getRequirement('company_name')"
                    :error="validate.company_name"
                    v-model="form.customer.company_name"
                    :is-readonly="isLoggedin"
                  ></form-input>
                  <!-- <form-input
                  my-id="formBirthdate"
                  my-label="Geburtsdatum"
                  my-placeholder="tt.mm.jjjj"
                  my-type="date"
                  v-model="form.customer.birth_date"
                ></form-input> -->
                </div>
                <div
                  class="orm-preload-page orm-preload-page-static orm-mt-64"
                  v-else
                >
                  <div class="orm-loader-spinner">
                    <i class="fa fa-spinner-third orm-rotate360"></i>
                  </div>
                </div>
              </div>
              <div class="orm-col-xs-12 orm-col-sm-6" v-if="requirements">
                <h2 class="orm-headline__h3">
                  {{ i18n("form/address") }}
                </h2>
                <div class="orm-form__block orm-form__container">
                  <form-input
                      v-if="getVisibility('street')"
                    my-id="formStreet"
                    :my-label="i18n('form/label/street')"
                    :is-required="getRequirement('street')"
                    :error="validate.street"
                    v-model="form.customer.street"
                    :is-readonly="isLoggedin"
                  ></form-input>
                  <form-input
                      v-if="getVisibility('zipcode')"
                    my-id="formZipcode"
                    :my-label="i18n('form/label/zipcode')"
                    :is-required="getRequirement('zipcode')"
                    :error="validate.zipcode"
                    v-model="form.customer.zipcode"
                    :is-readonly="isLoggedin"
                  ></form-input>
                  <form-input
                      v-if="getVisibility('city')"
                    my-id="formCity"
                    :my-label="i18n('form/label/city')"
                    :is-required="getRequirement('city')"
                    :error="validate.city"
                    v-model="form.customer.city"
                    :is-readonly="isLoggedin"
                  ></form-input>
                  <!-- <form-input
                  my-id="formCountryName"
                  my-label="Land"
                  v-model="form.customer.countryName"
                ></form-input> -->
                  <div v-if="countries && getVisibility('country_id')">
                    <form-select
                      my-id="formCountry"
                      :my-label="i18n('form/label/country') || 'Land'"
                      :my-options="countries"
                      my-options-value="id"
                      my-options-text="country"
                      :my-placeholder="i18n('form/placeholder/country')"
                      :is-required="getRequirement('country_id')"
                      :error="validate.country_id"
                      v-model="form.customer.country_id"
                      :is-readonly="isLoggedin"
                      v-if="!isLoggedin"
                    ></form-select>
                    <form-input
                      v-if="form.customer.country_id && isLoggedin"
                      my-id="formCountry"
                      :my-label="i18n('form/label/country')"
                      :is-readonly="true"
                      :model-value="
                        store.getters['customer/GET_COUNTRY'](
                          form.customer.country_id
                        )
                      "
                    ></form-input>
                  </div>

                  <div v-if="origins && getVisibility('origin')">
                    <form-select
                      my-id="formOrigin"
                      :my-label="
                        i18n('form/label/origin') ||
                          'Wie sind Sie auf uns aufmerksam geworden'
                      "
                      :my-options="origins"
                      my-options-value="origin"
                      my-options-text="translated_origin"
                      :my-placeholder="i18n('form/placeholder/origin')"
                      :is-required="getRequirement('origin')"
                      :error="validate.origin"
                      v-model="form.customer.origin"
                      :is-readonly="isLoggedin"
                      v-if="!isLoggedin"
                    ></form-select>
                    <form-input
                      v-if="form.customer.origin && isLoggedin"
                      my-id="formOrigin"
                      :my-label="i18n('form/label/origin')"
                      :is-readonly="true"
                      :model-value="
                        store.getters['customer/GET_ORIGIN'](
                          form.customer.origin
                        )
                      "
                    ></form-input>
                  </div>
                </div>

                <div v-if="showPayment && getVisibility('payment_method_id')">
                  <h2 class="orm-headline__h3">
                    {{ i18n("form/payment") }}
                  </h2>
                  <div class="orm-form__block orm-form__container">
                    <form-select
                      my-id="formPayment"
                      :my-label="i18n('form/label/payment')"
                      :my-options="paymentMethods"
                      my-options-value="id"
                      my-options-text="designation_web"
                      :my-placeholder="i18n('form/placeholder/payment')"
                      :is-required="getRequirement('payment_method_id')"
                      :error="validate.payment_method_id"
                      v-model="form.payment_method_id"
                    ></form-select>
                  </div>
                </div>
                <div
                  v-if="
                    store.getters['ORMgeneral/GET_MODULE']('ORM_LOGIN') ==
                      'J' && !isLoggedin
                  "
                >
                  <h2 class="orm-headline__h3">
                    {{ i18n("form/account") }}
                  </h2>
                  <div class="orm-form__block orm-form__container">
                    <form-checkbox
                      my-fontbase="14"
                      my-name="formCreateLogin"
                      :my-label="i18n('form/label/account')"
                      v-model="form.customer.create_login"
                      @change="
                        !form.customer.create_login
                          ? (form.customer.password = '')
                          : true
                      "
                    ></form-checkbox>
                  </div>
                  <div class="orm-form__block orm-form__container">
                    <form-pwd
                        v-if="form.customer.create_login"
                        my-id="password"
                        :my-label="i18n('form/label/password') || 'Passwort'"
                        :is-required="!isLoggedin && getRequirement('password')"
                        :error="validate.password"
                        v-model="form.customer.password"
                        :is-readonly="isLoggedin"
                        @update:modelValue="handlePasswordChange"
                    ></form-pwd>
                    <div v-if="passwordErrors.length" class="orm-login-error">
                      <small>
                        <ul class="orm-error-list orm-small">
                          <li v-for="(err, idx) in passwordErrors" :key="idx">
                            {{ i18n('password_error/' + err) || err}}
                          </li>
                        </ul>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="orm-row">
              <div class="orm-col-xs-12 orm-col-sm-6">
                <h2 class="orm-headline__h3">
                  {{ i18n("form/message") }}
                </h2>
                <div class="orm-form__block orm-form__container">
                  <form-textarea
                    my-id="formRemarks"
                    :my-label="i18n('form/label/remarks')"
                    :my-placeholder="i18n('form/placeholder/remarks')"
                    my-rows="5"
                    v-model="form.remarks"
                  ></form-textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="orm-col-xs-12 orm-col-md-3">
          <div
            class="orm-form__button__container"
            v-if="form.customer && requirements"
          >
            <button @click="sumbit" class="orm-button__cta outline small wide">
              {{ i18n("general/nextstep") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer />
</template>

<script>
import { defineComponent } from "vue";

import reservationheader from "@/components/reservation/header.vue"; // @ is an alias to /src
import reservationinfobar from "@/components/reservation/infobar_disabled.vue"; // @ is an alias to /src
import reservationinfobarAbo from "@/components/reservation/infobar_abo.vue"; // @ is an alias to /src

import FormInput from "@/components/ui/INPUTS/FormInput.vue"; // @ is an alias to /src
import FormPwd from "@/components/ui/INPUTS/FormPwd.vue"; // @ is an alias to /src
import FormSelect from "@/components/ui/INPUTS/FormSelect.vue"; // @ is an alias to /src
// import { formateDate } from "@/constants/formater";

import Footer from "@/components/widgets/Footer.vue"; // @ is an alias to /src
import store from "@/store";
import FormCheckbox from "@/components/ui/INPUTS/FormCheckbox.vue";
import FormTextarea from "@/components/ui/INPUTS/FormTextarea.vue";
import ErrorModal from "@/components/modals/modal-error.vue";
import i18n from "@/mixins/mixins";

import { buildDataLayer } from "@/constants/analytics";
import { routeToSteps } from "@/constants/getRoutes";

export default defineComponent({
  name: "ReservationStep3",
  components: {
    Footer,
    reservationheader,
    reservationinfobar,
    reservationinfobarAbo,
    FormInput,
    FormPwd,
    FormSelect,
    FormCheckbox,
    FormTextarea,
    ErrorModal,
  },
  mixins: [i18n],
  setup() {
    return {
      store,
      routeToSteps,
    };
  },
  data() {
    return {
      /* eslint-disable */
      form: {
        customer: {
          salutation_id: "",
          email: "",
          firstname: "",
          lastname: "",
          name: "",
          company_name: "",
          street: "",
          zipcode: "",
          city: "",
          country_id: "",
          origin: "",
          phone_number: "",
          allow_marketing: false,
          create_login: false,
          password: "",
          return_url: "",
        },
        payment_method_id: "",
        remarks: "",
      },
      paymentMethods: Array,
      salutationMethods: Array,
      language: String,
      showPayment: true,
      filterSection: "commentData",
      validate: {},
      errors: [],
      erroremailexist: false,
      errorpasswordweak: false,
      passwordErrors: [], // neue Fehlerliste
      error: {
        show: false,
        data: {
          header: this.i18n("error/tocarselect/header"),
          content: this.i18n("error/tocarselect/content"),
          buttonFirst: "Reservation_Step1",
          buttonFirstLabel: this.i18n("error/tocarselect/buttonFirstLabel"),
        },
      },
      isLoggedin: false,
      requirements: null,
      stationSelected: store.getters["userSession/GET_STATION"],
      resnormal: true,
      countries: Array,
      origins: Array,
      debounceTimeout: null
    };
  },
  async created() {
    this.countries = await store.getters["customer/GET_COUNTRIES"];
    this.origins = await store.getters["customer/GET_ORIGINS"];

    const reservation = await store.getters["reservation/GET_RESERVATION"];
    if (reservation == null) {
      this.error.show = true;
      return false;
    }
    const stationSelected = await store.getters["userSession/GET_STATION"];
    console.log("stationSelected", stationSelected);
    if (stationSelected == null) {
      this.error.show = true;
      return false;
    }
    const branch = await store.getters["stations/GET_STATION_BY_ID"](
      this.stationSelected
    ).branch;
    if (
      (branch == "Auto-Abo" && this.$route.name != "Abo_Step3") ||
      (branch != "Auto-Abo" && this.$route.name != "Reservation_Step3")
    ) {
      this.error.show = true;
      return false;
    }
    if (branch == "Auto-Abo") this.resnormal = false;
    const logincheck = await store.getters["userSession/IS_LOGGEDIN"];
    const GET_SALUTATIONS = await store.getters["customer/GET_SALUTATIONS"];
    this.language = await store.getters["general/GET_LANGUAGE"];
    if (logincheck) this.isLoggedin = true;
    store.dispatch("reservation/DELETE_SUCCESS_RESERVATION");

    const salutationsArray = [];

    if (store.getters["ORMgeneral/GET_MODULE"]("ZAHLUNGSDIENSTLEISTER") == "J") {
      const paymentType = await store.getters["reservation/GET_PAYMENTTYPE"];
      if (
        paymentType &&
        Object.keys(paymentType)[0] === process.env.VUE_APP_PAYMENT_ONLINE
      ) {
        this.showPayment = false;
      }
    }

    for (const key in GET_SALUTATIONS) {
      // if (GET_SALUTATIONS[key].language == this.language) {
      salutationsArray.push(GET_SALUTATIONS[key]);
      // }
    }

    this.salutationMethods = salutationsArray;

    const customer = await store.getters["customer/GET_CUSTOMER"];

    this.form = customer;
    if (customer.customer.salutation_id == null) {
      this.form.customer.salutation_id = salutationsArray[0].id;
    }
    this.form.customer.country_id = await store.getters["customer/GET_COUNTRY"](
      "DE"
    ).id;
    const cargroup = await store.getters["userSession/GET_CARGROUP"];
    await store
      .dispatch("reservation/GET_PAYMENT_METHODS", cargroup)
      .then((result) => {
        this.paymentMethods = result;
        // console.log(result);
      });

    if (store.getters["ORMgeneral/GET_MODULE"]("ZAHLUNGSDIENSTLEISTER") == "J") {
      const paymentType = await store.getters["reservation/GET_PAYMENTTYPE"];
      if (
        paymentType &&
        Object.keys(paymentType)[0] === process.env.VUE_APP_PAYMENT_ONLINE
      ) {
        this.form.payment_method_id =
          store.getters["reservation/GET_PAYMENT_SELECTION"].type;
      }
    }
    this.requirements = await store.getters[
      "ORMgeneral/GET_INPUTFIELD_REQUIREMENTS"
    ]("step3_personal_information");
    this.requirements.forEach((element) => {
      if (element.required) this.validate[element.name] = false;
    });
  },
  methods: {
    async sumbit() {
      if (await this.validateForm()) {
        if (
            this.form.customer.create_login &&
            this.form.customer.password !== "" &&
            !this.isLoggedin
        ) {
          const valid = await this.validPassword(this.form.customer.password);
          if (!valid) {
            this.validate.password = true;
            return;
          }
        }
        if (this.form.customer.create_login) {
          if (this.form.customer.password === "") {
            this.form.customer.return_url =
              process.env.VUE_APP_CUSTOMER_PATH + "activatepassword/";
          } else {
            this.form.customer.return_url =
              process.env.VUE_APP_CUSTOMER_PATH + "activate/";
          }
        } else {
          this.form.customer.return_url = "";
        }
        await store
          .dispatch("reservation/SET_CUSTOMER", this.form)
          .then((result) => {
            buildDataLayer("add_shipping_info", {}, null);
            routeToSteps(this, 4);
          });
      }
    },
    getRequirement(input) {
      const required = this.requirements.find((x) => x.name === input);
      return required ? required.required : null;
    },
    getVisibility(input) {
      const visible = this.requirements.find((x) => x.name === input);
      return visible ? visible.visible : null;
    },
    async validateForm() {
      this.errors = [];
      const paymentType = store.getters["reservation/GET_PAYMENTTYPE"];

      for (const formfield in this.validate) {
        if (Object.hasOwnProperty.call(this.validate, formfield)) {
          let element = this.form.customer[formfield];

          // Validierung nur wenn das Feld sichtbar ist
          if (this.getVisibility(formfield)) {
            if (formfield == "payment_method_id") {
              element = this.form[formfield];
              if (store.getters["ORMgeneral/GET_MODULE"]("ConCardis") == "J") {
                if (
                    !element &&
                    Object.keys(store.getters["reservation/GET_PAYMENTTYPE"])[0] ===
                    process.env.VUE_APP_PAYMENT_OFFLINE
                ) {
                  this.validate[formfield] = true;
                  this.errors.push(formfield + " required.");
                } else {
                  this.validate[formfield] = false;
                }
              } else {
                if (!element) {
                  this.validate[formfield] = true;
                  this.errors.push(formfield + " required.");
                } else {
                  this.validate[formfield] = false;
                }
              }
            }

            else if (formfield == "email") {
              const validMail = await this.validEmail(element);
              if (!validMail) {
                this.validate[formfield] = true;
                this.errors.push(formfield + " required.");
              } else {
                this.validate[formfield] = false;
              }
            }

            else if (formfield == "password") {
              if (store.getters["ORMgeneral/GET_MODULE"]("ORM_LOGIN") == "J" && !this.isLoggedin) {
                const validPassword = await this.validPassword(element);
                if(!validPassword) {
                  this.validate[formfield] = true;
                  this.errors.push(formfield + " required.");
                } else {
                  this.validate[formfield] = false;
                }
                if (!element && this.form.customer.create_login) {
                  const validPassword = await this.validPassword(element);
                  if(!validPassword) {
                    this.validate[formfield] = true;
                    this.errors.push(formfield + " required.");
                  } else {
                    this.validate[formfield] = false;
                  }
                } else {
                  this.validate[formfield] = false;
                }
              } else {
                this.validate[formfield] = false;
              }
            }

            else if (!element) {
              this.validate[formfield] = true;
              this.errors.push(formfield + " required.");
            } else {
              this.validate[formfield] = false;
            }
          } else {
            this.validate[formfield] = false;
          }
        }
      }

      if (this.errors.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    async validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(email)) return false;
      if (this.isLoggedin) return true;
      if (!this.form.customer.create_login) return true;
      const response = await store
        .dispatch("customer/CHECK_EMAIL_EXCISTS", email)
        .then((result) => {
          if (result.status == 400) {
            this.erroremailexist = true;
            return false;
          } else {
            this.erroremailexist = false;
            return true;
          }
        });
      return response;
    },
    handlePasswordChange(newVal) {
      this.form.customer.password = newVal;

      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.validPassword(newVal);
      }, 300);
    },
    async validPassword(pw) {
      if (this.isLoggedin || !this.form.customer.create_login) return true;

      try {
        const result = await this.$store.dispatch("customer/CHECK_PASSWORD_STRENGTH", pw);
        this.errorpasswordweak = !result.data.valid;

        if (!result.data.valid) {
          this.passwordErrors = result.data.errors || [];
        } else {
          this.passwordErrors = [];
        }
        return result.data.valid;
      } catch (error) {
        console.error("Fehler bei der Passwortprüfung:", error);
        this.errorpasswordweak = true;
        this.passwordErrors = [];
        return false;
      }
    }
  },
});
</script>
